// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".service-page[data-v-338c3698] h2{margin-bottom:1rem;margin-top:4rem}.faq-accordion[data-v-338c3698] .content p{margin-bottom:0}.small-gutter .ui-col[data-v-338c3698] .default-gutter .ui-col,.small-gutter .ui-col[data-v-338c3698] .normal-gutter .ui-col{padding-left:1rem!important;padding-right:1rem!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
